export default {
    path: "/perfil",
    component: () => import("~/pages/perfil/index.vue"),
}